import { useEffect } from "react";

interface ConfirmDialogProps {
	title: string;
	message: string;
	confirmLabel: string;
	cancelLabel: string;
	/** Colore l'action de confirmation en rouge pour une action irréversible. */
	isDestructive?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

/**
 * Confirmation modale réutilisable. Le projet interdit `window.confirm` : elle
 * n'est pas stylable, ne se teste pas, et bloque le thread de rendu.
 * Reprend le balisage des modales existantes de l'admin (`modal-overlay`…).
 */
export function ConfirmDialog({
	title,
	message,
	confirmLabel,
	cancelLabel,
	isDestructive,
	onConfirm,
	onCancel,
}: ConfirmDialogProps) {
	// Échap ferme la modale : attendu de toute boîte de dialogue.
	useEffect(() => {
		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === "Escape") onCancel();
		};
		document.addEventListener("keydown", onKeyDown);
		return () => document.removeEventListener("keydown", onKeyDown);
	}, [onCancel]);

	return (
		<div className="modal-overlay" onClick={onCancel}>
			<div
				className="modal-content"
				style={{ maxWidth: "460px" }}
				role="dialog"
				aria-modal="true"
				aria-label={title}
				onClick={(event) => event.stopPropagation()}
			>
				<div className="modal-header">
					<h2>{title}</h2>
					<button className="modal-close" onClick={onCancel} aria-label={cancelLabel}>
						&times;
					</button>
				</div>
				<div className="modal-body">
					<p>{message}</p>
				</div>
				<div className="modal-footer">
					<button type="button" className="btn btn-secondary" onClick={onCancel}>
						{cancelLabel}
					</button>
					<button
						type="button"
						className={`btn ${isDestructive ? "btn-danger" : "btn-primary"}`}
						onClick={onConfirm}
					>
						{confirmLabel}
					</button>
				</div>
			</div>
		</div>
	);
}
